import "./App.css";
import Routing from "./Modules/Routes";
import { Provider, useSelector } from "react-redux";
import store from "./Redux/store";
import './Admin/Pages/adminPage.css';
import toast, { Toaster } from "react-hot-toast";
import { useEffect } from "react";


function App() {

  return (
    <div className="App">
      <Provider store={store}>
        <Routing />
        <Toaster position="top-right" />
      </Provider>
    </div>
  );
}

export default App;
